// components/UserProfile/UserProfileButton.js
import React, { useRef } from 'react';
import { IconButton, Avatar, Tooltip } from '@mui/material';
import { getInitialsFromEmail } from '../../utils/userUtils';
import styles from './UserProfile.module.css';

/**
 * UserProfileButton component displays a button with the user's profile picture or initials
 * that triggers the user dropdown menu when clicked.
 */
const UserProfileButton = ({ 
  profilePicture, 
  userName, 
  userEmail, 
  onClick,
  onFileChange,
  isBetaFeatureEnabled
}) => {
  const fileInputRef = useRef(null);
  
  const userInitial = userName && userName !== 'User' 
    ? userName.charAt(0).toUpperCase() 
    : (userEmail ? getInitialsFromEmail(userEmail) : 'U');
  
  return (
    <>
      <Tooltip title="Open User Menu" arrow placement="bottom">
        <IconButton 
          onClick={onClick}
          className={styles.userAvatar}
          aria-label="User menu"
        >
        {profilePicture ? (
          <Avatar 
            className={styles.avatar} 
            src={profilePicture}
            alt={userName}
            sx={{
              transition: 'all 0.2s ease',
              '&:hover': {
                transform: 'scale(1.05)',
                boxShadow: '0 4px 12px rgba(29, 159, 159, 0.3)'
              }
            }}
          />
        ) : (
          <Avatar 
            className={styles.avatar}
            sx={{
              bgcolor: '#1d9f9f',
              transition: 'all 0.2s ease',
              '&:hover': {
                transform: 'scale(1.05)',
                bgcolor: '#168080',
                boxShadow: '0 4px 12px rgba(29, 159, 159, 0.3)'
              }
            }}
          >
            {userInitial}
          </Avatar>
        )}
        </IconButton>
      </Tooltip>
      
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        accept="image/*"
        onChange={onFileChange}
      />
    </>
  );
};

export default UserProfileButton;
